import React from "react";
import { Button, Table, ListGroup, Accordion } from "react-bootstrap";

const Summary = ({ formData, setActiveStep }) => {
  return (
    <div className="p-4">
      <h5 className="fw-bold mb-4">Summary</h5>
      <hr />

      <Accordion defaultActiveKey="0">
        {/* Participants Summary */}
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h6 className="fw-bold mb-0">Participants</h6>
          </Accordion.Header>
          <Accordion.Body>
            <Button
              variant="primary"
              size="sm"
              className="mb-3"
              onClick={() => setActiveStep(0)}
            >
              Edit
            </Button>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Contact</th>
                </tr>
              </thead>
              <tbody>
                {formData.participants.map((participant, index) => (
                  <tr key={index}>
                    <td>
                      {participant.firstName} {participant.lastName}
                    </td>
                    <td>{participant.designation}</td>
                    <td>{participant.contact}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>

        {/* Selected Industries Summary */}
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <h6 className="fw-bold mb-0">Selected Industries</h6>
          </Accordion.Header>
          <Accordion.Body>
            <Button
              variant="primary"
              size="sm"
              className="mb-3"
              onClick={() => setActiveStep(1)}
            >
              Edit
            </Button>
            <ListGroup>
              {formData.industries.map((industry, index) => (
                <ListGroup.Item key={index}>{industry}</ListGroup.Item>
              ))}
            </ListGroup>
          </Accordion.Body>
        </Accordion.Item>

        {/* Area of Expertise Summary */}
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <h6 className="fw-bold mb-0">Area of Expertise</h6>
          </Accordion.Header>
          <Accordion.Body>
            <Button
              variant="primary"
              size="sm"
              className="mb-3"
              onClick={() => setActiveStep(2)}
            >
              Edit
            </Button>
            {Object.entries(formData.expertise).map(([section, items]) => (
              <div key={section} className="mb-3">
                <strong>{section}:</strong>
                <ListGroup>
                  {items.map((item, index) => (
                    <ListGroup.Item key={index}>{item}</ListGroup.Item>
                  ))}
                </ListGroup>
              </div>
            ))}
          </Accordion.Body>
        </Accordion.Item>

        {/* Selected Time Slots Summary */}
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <h6 className="fw-bold mb-0">Selected Time Slots</h6>
          </Accordion.Header>
          <Accordion.Body>
          <Button
              variant="primary"
              size="sm"
              className="mb-3"
              onClick={() => setActiveStep(3)}
            >
              Edit
            </Button>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                {formData.selectedTimeSlots.map((slot, index) => (
                  <tr key={index}>
                    <td>{new Date(slot.date).toLocaleDateString()}</td>
                    <td>{slot.startTime} - {slot.endTime}</td>
                    <td>{slot.duration}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default Summary;
